import Vue from "vue"
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Loader from '@/components/loader/Loader.vue'
import { EventBus } from '@/services/EventBus'

export default {
    name: 'Player',
    inject: ['auth'],
    data() {
        return {
            domain: location.origin,
            loading: true,
            options: {
                login: this.$store.state.user.login,
                password: this.auth.getTokenFromStorage(localStorage.getItem('token'))[1],
                monitor_id: PARAMS.PLAYER.monitorId,
                transport: PARAMS.PLAYER.transport,
            },
            camsData: null,
            intervalDateVideo: null
        }
    },
    props: {
        data: {
            type: Object,
        },
    },
    created() {
        window.addEventListener('message', this.getMessage, false)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.getMessage)
        EventBus.$off('views:select')
        EventBus.$off('mode:change')
        EventBus.$off('cam:dragstart')
        EventBus.$off('export-files')
        EventBus.$off('stop-export-file')
    },
    mounted() {
        EventBus.$on('views:select', this.update)
        EventBus.$on('mode:change', this.changeMode)
        EventBus.$on('cam:dragstart', this.getCamsData)
        EventBus.$on('export-files', this.exportFiles)
        EventBus.$on('stop-export-file', this.stopExportFile)

        this.preloading()

        const startForm = document.createElement('form')
        startForm.setAttribute('method', 'post')
        startForm.setAttribute('target', 'webview_player')
        startForm.setAttribute('action', '/webview/video')
        startForm.setAttribute('style', 'display: none')
        let startFromHtml = ''
        const paramsSend = {
            command: 'show_monitor',
            auto_logon: 1,
            close_current_session: 1
        }
        Object.assign(paramsSend, this.params)
        Object.keys(paramsSend).forEach(key => {
            startFromHtml += `<input name="${key}" value="${paramsSend[key]}">`
        })
        startForm.innerHTML = startFromHtml
        document.body.appendChild(startForm)
        startForm.submit()
        startForm.remove()


    },
    computed: {
        ...mapGetters({
            stream: 'getStream'
        }),
        params() {
            return {
                ...this.options,
                ...this.data,
                stream_role: this.stream
            }
        }
    },
    watch: {
        stream() {
            this.sendMessage({
                command: 'init',
                stream_role: this.stream
            })
        }
    },
    methods: {
        update() {
            if (this.params) {
                const data = {
                    command: 'show_monitor',
                    monitor_id: this.params.monitor_id,
                    mode: this.params.mode,
                    camera_list: this.params.camera_list.join(','),
                    layout: this.params.layout
                }

                if (this.params.time)
                    data.time = this.params.time

                this.sendMessage(data)
            }
        },
        changeMode() {
            this.sendMessage({
                command: 'changeMonitorMode',
                mode: this.params.mode
            })
        },
        sendMessage(data) {
            if (this.$refs.player)
                this.$refs.player.contentWindow.postMessage(JSON.stringify(data), '*')
        },
        preloading() {
            this.loading = true
            setTimeout(() => this.loading = false, 1500)
        },
        getCamsData() {
            this.sendMessage({
                command: 'cameras_data',
                request_id: 1,
            })
        },
        exportFiles(data){
            const startDateFormat = data.start_date.creationData().format;
            const endDateFormat = data.end_date.creationData().format;
            const startDateView = data.start_date.format(startDateFormat);
            const endDateView = data.end_date.format(endDateFormat);
            const formatSend = 'DD-MM-YYYY HH:mm:ss.000';
            data.start_date = data.start_date.format(formatSend);
            data.end_date = data.end_date.format(formatSend);
            this.intervalDateVideo = `${startDateView.slice(0,16)} - ${endDateView.slice(0,16)}`;
            const exportParams = {
                ...data,
                command: 'arch_cnv_export',
                camera_list: this.params.camera_list.join(';'),
            };
            if(!!exportParams.camera_id) {
                exportParams.camera_list = exportParams.camera_id;
                delete exportParams.camera_id;
            }
            this.sendMessage(exportParams);
        },
        stopExportFile(id){
            this.sendMessage({
                command: 'arch_cnv_cancel',
                id: id,
            })
        },
        getMessage(event) {
            // console.log('event', event)
            if (event && event.data && typeof event.data === 'string') {
                let data = JSON.parse(event.data)
                switch(data.action) {
                    case 'alerts':
                        this.$router.push({ name: 'alarms', query: { cams: data.camera_id } })
                        break
                    case 'onmap':
                        let params = null

                        this.$store.state.maps.forEach(item => {
                            item.map.forEach(i => {
                                i.objects.forEach(o => {
                                    if (data.camera_id == o.id)
                                        params = { mapGroupId: item.id, mapId: i.id }
                                })
                            })
                        })

                        if (params) {
                            this.$store.commit('setCamIdFromCell', data.camera_id)
                            this.$router.push({ name: 'map', params: params, })
                        }
                        break

                    case 'setPlayerMode':
                        this.$store.commit('setMode', data.mode)
                        break

                    case 'closeCamera':
                        this.$store.commit('removeCamFromView', {
                            camId: data.camera_id,
                            viewId: this.$store.getters.getActiveView.id
                        })
                        break

                    case 'camera_drop':
                        if (this.camsData) {
                            this.camsData.list.forEach(item => {
                                if (item.camera_index == data.camera_index) {
                                    if (item.camera_id === 'null') {
                                        this.$store.commit('addCamsIntoView', {
                                            camIds: [ data.camera_id ],
                                            viewId: this.$store.getters.getActiveView.id
                                        })
                                    } else {
                                        this.$store.commit('replaceCam', {
                                            camId: data.camera_id,
                                            replacedCamId: item.camera_id,
                                            viewId: this.$store.getters.getActiveView.id
                                        })
                                    }
                                }
                            })
                        }

                        break

                    case 'cameras_data':
                        this.camsData = data
                        break
                    case 'arch_cnv_poll': {
                        this.$store.commit('setUplodedVideos', {...data, intervalDateVideo: this.intervalDateVideo});
                        break
                    }
                }

                switch (data.command) {
                    case 'arch_cnv_export_show_control':
                        EventBus.$emit('open:export', data.camera_id);
                        break;
                    case 'init':
                        if (+data.arch_cnv_enabled === 0) {
                            this.$store.commit('setArchCnvEnabled', false)
                        } else {
                            this.$store.commit('setArchCnvEnabled', true)
                        }
                        break;
                }
            }
        }
    },
    components: {
        Loader
    },
}



// WEBPACK FOOTER //
// ./src/components/player/player.js